type CustomerWithSocialAndLegalName = {
  socialName?: string;
  legalName: string;
};

export function formatCustomerPreferredName(customer: CustomerWithSocialAndLegalName) {
  return customer.socialName || customer.legalName;
}
